import React from 'react';
import CrmListPage from '../components/listing/CrmListPage';
import MediaAssetLibrary from '../components/media/MediaAssetLibrary';
import './media.scss';

export default function Media() {
  return (
    <CrmListPage
      title="Media"
      subtitle="Manage images and videos used across your storefronts and dashboard."
      hideSavedViews
      hideToolbar
      hideFooter
    >
      <div className="media-page__content">
        <MediaAssetLibrary manage />
      </div>
    </CrmListPage>
  );
}
